import { Typographies } from '@/theme';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { Select, MenuItem, InputLabel, styled } from '@mui/material';

interface IPropsSelectStyled {
  withBorder: boolean;
  maxWidth?: number;
}

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  height: theme.typography.pxToRem(58),
  '&:not(:first-child)': {
    borderTop: `${theme.typography.pxToRem(0.2)} solid ${
      theme.palette.dark['dark_3.05']
    }`,
  },
}));

export const InputLabelStyled = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
}));

export const SelectStyled = styled(Select<string>)<IPropsSelectStyled>(
  ({ theme, withBorder, maxWidth }) => ({
    '&.MuiInputBase-root': {
      fontSize: theme.typography.body1.fontSize,
      fontFamily: Typographies.FONT_FAMILY_MAIN,
      borderRadius: theme.spacing(0.5),

      color: theme.palette.dark.dark_1,
      minWidth: theme.typography.pxToRem(230),
      maxWidth: maxWidth ? theme.typography.pxToRem(maxWidth) : '',
      backgroundColor: theme.palette.white.light,
      '&.MuiOutlinedInput': {
        borderRadius: theme.spacing(0.5),
      },
      '& .MuiSelect-icon': {
        top: '30%',
      },
      '& fieldset': {
        border: withBorder ? `1px solid ${theme.palette.dark.dark_3}` : '0',
      },
    },
  }),
);

export const ChevronDownStyled = styled(ChevronDownIcon)(({ theme }) => ({
  width: theme.typography.pxToRem(11),
  height: theme.typography.pxToRem(6),
}));
